import { render, staticRenderFns } from "./Departure.vue?vue&type=template&id=253adf88&scoped=true&"
import script from "./Departure.vue?vue&type=script&lang=js&"
export * from "./Departure.vue?vue&type=script&lang=js&"
import style0 from "./Departure.vue?vue&type=style&index=0&id=253adf88&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "253adf88",
  null
  
)

export default component.exports